import axios from 'axios';
var dataFetcher = function (url, data, authToken, withCredentials) {
    if (withCredentials === void 0) { withCredentials = true; }
    var headers = authToken ? { Authorization: "Bearer ".concat(authToken) } : undefined;
    return axios({
        url: url,
        data: data,
        method: data ? 'POST' : 'GET',
        // note: axios needs to use `withCredentials: true` in order for
        // Sitecore cookies to be included in CORS requests
        // which is necessary for analytics and such
        withCredentials: withCredentials,
        headers: headers,
    });
};
export default dataFetcher;
